export const SITE_ADDRESS = process.env.REACT_APP_URL;
export const SITE_ADDRESS_PEMBELAJARAN = process.env.REACT_APP_URL_PEMBELAJARAN;
export const SCHOOL_NAME = process.env.REACT_APP_SCHOOLNAME;